// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Ev-S","selects":"Documents_selects__3IWRp"};